// uat

import React, { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import {
  Button,
  Typography,
  Toolbar,
  Dialog,
  Slide,
  IconButton,
  AppBar,
  ButtonGroup,
  TextField,
  MenuItem,
  Grid,
  Checkbox,
  Modal,
  Tooltip,
  Box,
  FormControlLabel,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import LoadingIcon from "../../../../reusable-component/LoadingIcon";
import InputField from "../../../../reusable-component/InputField";
import generateAlias from "../../generateAlias";
import { useAxios } from "../../../../contexts/AxiosProvider";
import { BenchlingApi } from "../../../../services/BenchlingApi";

const styleLoading = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const nameRegex = /^[a-zA-Z0-9_]{1,35}$/;

const NodeModal_WriteToBenchling = ({
  open,
  handleClose,
  nodeId,
  nodeName,
  nodes,
  edges,
  changeNodeName,
  setNodes,
  workflow,
}) => {
  const INITIALSTATE = {
    format: "table",
    instrument_name: workflow.engagement.engagementName,
    alias: generateAlias(nodeName, nodeId),
    df: "",
    sample_view: true,
    project_name: "",
    project_id: "",
    entry_id: "",
    entry_name: "",
    webURL: "",
    schema_id: "",
    schema_name: "",
    table_id: "",
    table_name: "",
    start_date: "",
  };

  const PROJECT_DATA_INITIAL_STATE = {
    projects: [
      {
        project_id: "",
        project_name: "",
      },
    ],
  };
  const ENTRIES_DATA_INITIAL_STATE = {
    entries: [
      {
        entry_name: "",
        entry_id: "",
        webURL: "",
      },
    ],
  };

  const SCHEMA_DATA_INITIAL_STATE = {
    schemas: [
      {
        schema_id: "",
        schema_name: "",
      },
    ],
  };

  const ENTRY_DATA_INITIAL_STATE = {
    entry_id: "",
    entry_name: "",
    webURL: "",
    schemas: [
      {
        schema_id: "",
        schema_name: "",
        tables: [
          {
            table_id: "",
            table_name: "",
          },
        ],
      },
    ],
  };

  const [projectData, setProjectData] = useState(PROJECT_DATA_INITIAL_STATE);
  const [entriesData, setEntriesData] = useState(ENTRIES_DATA_INITIAL_STATE);
  const [entryMetaData, setEntryMetaData] = useState(ENTRY_DATA_INITIAL_STATE);
  const [schemaData, setSchemaData] = useState(SCHEMA_DATA_INITIAL_STATE);

  const { enqueueSnackbar } = useSnackbar();
  const axios = useAxios();
  const [formField, setFormField] = useState(INITIALSTATE);
  const [disableForm, setDisableForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tableName, setTableName] = useState([]);
  const [toggleType, setToggleType] = useState("S3");
  const [headerName, setHeaderName] = useState([]);
  const [fetchedHeader, setFetchedHeader] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [tempHeader, setTempHeader] = useState([]);
  const [errors, setErrors] = useState({ stream_interval: "" });
  const [prevNodeName, setPrevNodeName] = useState("");
  const [aliasError, setAliasError] = useState("");
  const [schemaOptions, setSchemaOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [searchText, setSearchText] = useState("");

  const filteredSchemas = schemaData.schemas.filter((schema) =>
    schema.schema_name.toLowerCase().includes(searchText.toLowerCase())
  );

  const [refreshModalOpen, setRefreshModalOpen] = useState(false);
  const handleRefreshModalOpen = () => setRefreshModalOpen(true);
  const handleRefreshModalClose = () => setRefreshModalOpen(false);

  // useEffect(() => {
  //   fetchSchemas(date);
  // }, [date]);

  const filteredSchemaOptions = schemaOptions.filter((option) =>
    option.schemaName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleHeaderChange = (obj) => {
    const selectedIndex = headerName.findIndex((object) => {
      return object.header === obj.header;
    });

    if (selectedIndex === -1 && obj.checked) {
      setHeaderName([...headerName, obj]);

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              header: obj.header,
              alias: obj.alias,
              checked: true,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && obj.checked) {
      setHeaderName((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              checked: obj.checked,
              header: obj.header,
              alias: obj.alias,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              checked: obj.checked,
              header: obj.header,
              alias: obj.alias,
              cast_datatype: obj.cast_datatype,
              attribute_type: obj.attribute_type,
              default_value: obj.default_value,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && !obj.checked) {
      setHeaderName((current) =>
        current.filter((object) => {
          return object.header !== obj.header;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              checked: false,
              alias: "",
              cast_datatype: "string",
              attribute_type: "static",
              default_value: "",
            };
          }

          return object;
        })
      );
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = fetchedHeader.map((n) => {
        const all = {
          header: n.header,
          alias: n.alias,
          checked: true,
          cast_datatype: n.cast_datatype ? n.cast_datatype : "string",
          attribute_type: "static",
          default_value: "",
          // type: n.type ? n.type : 'string',
          // deleted: n.deleted ? n.deleted : false,
        };
        return all;
      });
      setHeaderName(newSelecteds);
      return;
    }
    setHeaderName([]);
  };

  const isSelected = (name) => {
    const selectedIndex = headerName.findIndex((object) => {
      return object.header === name;
    });
    return selectedIndex !== -1;
  };

  const store = JSON.parse(sessionStorage.getItem("allNodes"));

  const getLocalData = () => {
    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            setPrevNodeName(node.step_name);
          }
        });
      });

      // setFormField({ ...formField, df: prev_alias });

      const isHeader = header.some((item) => item.header);
      if (isHeader) {
        const newArr = [];

        if (prevNodeName === "Join") {
          header.forEach((el) => {
            const exist = el.header.split(".").length;

            if (exist === 2) {
              const head = el.header.split(".")[1];
              newArr.push({ ...el, header: el.alias ? el.alias : head });
            }
          });
        }
        if (newArr.length > 0) {
          header = newArr;
        }

        const uniqueHeader = [];

        const uniqueArray = header.filter((element) => {
          const isDuplicate = uniqueHeader.includes(element.header);

          if (!isDuplicate) {
            uniqueHeader.push(element.header);
            return true;
          }

          return false;
        });

        const head = [];

        const newHeader = uniqueArray.map((el) => {
          return {
            ...el,
            header: el.alias ? el.alias : el.header,
            alias: el.alias ? "" : el.alias,
          };
        });

        newHeader.forEach((el) => {
          head.push({ label: el.header });
        });

        setHeaders(head);
        setFetchedHeader(newHeader);
      } else {
        setHeaders([]);
        setFetchedHeader([]);
      }
      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          const writeBenchlingData = {
            df: prev_alias,
            format: "table",
            alias: generateAlias(nodeName, nodeId),
            sample_view: node.formField.write_benchling.sample_view,
            entry_id: node.formField.write_benchling.entry_id,
            entry_name: node.formField.write_benchling.entry_name,
            schema_id: node.formField.write_benchling.schema_id,
            schema_name: node.formField.write_benchling.schema_name,
            table_id: node.formField.write_benchling.table_id,
            table_name: node.formField.write_benchling.table_name,
            project_name: node.formField.write_benchling.project_name,
            project_id: node.formField.write_benchling.project_id,
            webURL: node.formField.write_benchling.webURL,
            instrument_name: node.formField.write_benchling.instrument_name,
            start_date: node.formField.write_benchling.start_date
              ? dayjs(node.formField.write_benchling.start_date).format(
                  "YYYY-MM-DD"
                )
              : "",
          };
          setFormField(writeBenchlingData);
          setHeaderName(node.headerName);
          setTempHeader(node.headerName);
          setFetchedHeader(node.fetchedHeader);
          setToggleType(node.toggleType);
          if (node.disabled) {
            setDisableForm(node.disabled);
          }
        }
      });
    }
  };

  const validate = () => {
    const numbers = /^[0-9]+$/;
    if (!String(formField?.stream_interval)?.match(numbers)) {
      setErrors({ ...errors, stream_interval: "Only integres allowed" });
    } else {
      setErrors({ stream_interval: "" });
    }
  };

  useEffect(() => {
    validate();
  }, [formField.stream_interval, errors.stream_interval]);

  useEffect(() => {
    setFormField(INITIALSTATE);
    setDisableForm(false);
    setFetchedHeader([]);
    setHeaderName([]);
    setToggleType("S3");
    getLocalData();
  }, [nodeId]);

  const sendFormData = {
    nodeId,
    nodeName,
    formField,
    disabled: false,
    step_name: nodeName,
  };

  const refreshAllState = () => {
    handleRefreshModalOpen();

    let updateNodes = JSON.parse(sessionStorage.getItem("updatedNodes")) || [];

    let count = 0;

    setNodes((nds) =>
      nds.map((node) => {
        if (count <= updateNodes.length && node.id === updateNodes[count]) {
          node.position.x -= 0.1;
          count++;
        }

        return node;
      })
    );

    updateNodes = updateNodes.filter((el) => el !== nodeId);

    sessionStorage.setItem("updatedNodes", JSON.stringify(updateNodes));

    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (findSrcNodeId.length === 0) {
      setFormField(INITIALSTATE);
      setDisableForm(false);
      setFetchedHeader([]);
      setHeaderName([]);

      enqueueSnackbar("No source node is connected !!!", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      handleRefreshModalClose();
      return;
    }

    let nodesExist = false;

    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        nodesExist = true;
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            setPrevNodeName(node.step_name);
          }
        });
      });

      setFormField({ ...formField, df: prev_alias });
      const isHeader = header.some((item) => item.header);

      if (isHeader) {
        const newArr = [];

        if (prevNodeName === "Join") {
          header.forEach((el) => {
            const exist = el.header.split(".").length;

            if (exist === 2) {
              const head = el.header.split(".")[1];
              newArr.push({ ...el, header: el.alias ? el.alias : head });
            }
          });
        }
        if (newArr.length > 0) {
          header = newArr;
        }

        const uniqueHeader = [];

        const uniqueArray = header.filter((element) => {
          const isDuplicate = uniqueHeader.includes(element.header);

          if (!isDuplicate) {
            uniqueHeader.push(element.header);
            return true;
          }

          return false;
        });

        const head = [];

        const newHeader = uniqueArray.map((el) => {
          return {
            ...el,
            header: el.alias ? el.alias : el.header,
            alias: el.alias ? "" : el.alias,
          };
        });

        newHeader.forEach((el) => {
          head.push({ label: el.header });
        });

        setHeaders(head);

        if (nodesExist) {
          store.forEach((node) => {
            if (node.nodeId === nodeId) {
              setFormField(node.formField);
              setHeaderName(node.headerName);
              setToggleType(node.toggleType);

              const nonExistingHeader = [];
              node.fetchedHeader.forEach((item) => {
                const index = newHeader.findIndex(
                  (x) => x.header === item.header
                );

                if (index !== -1) {
                  nonExistingHeader.push(item);
                }
              });

              newHeader.forEach((el) => {
                const index = nonExistingHeader.findIndex(
                  (x) => x.header === el.header
                );

                if (index === -1) {
                  nonExistingHeader.push({
                    ...el,
                    header: el.alias ? el.alias : el.header,
                    alias: el.alias ? "" : el.alias,
                  });
                }
              });

              setFetchedHeader(nonExistingHeader);
            }
          });
        } else {
          setFetchedHeader(newHeader);
        }
      } else {
        setFetchedHeader([]);
      }
    }

    enqueueSnackbar("Data Refreshed!!!", {
      variant: "Success",
      autoHideDuration: 3000,
      anchorOrigin: { vertical: "top", horizontal: "right" },
    });
    handleRefreshModalClose();
  };

  // const handleInputChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   const fieldValue = type === "checkbox" ? checked : value;

  //   // Directly set the form field based on the input name and value
  //   setFormField((prevState) => ({
  //     ...prevState,
  //     [name]: fieldValue,
  //   }));

  //   // Additional specific logic for certain fields
  //   if (name === "alias" && !nameRegex.test(fieldValue)) {
  //     setAliasError("Special Characters are not Allowed");
  //   } else if (name === "alias") {
  //     setAliasError("");
  //   }
  // };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormField((prevState) => {
      let updatedState = { ...prevState, [name]: fieldValue };

      if (name === "alias") {
        if (!nameRegex.test(fieldValue)) {
          setAliasError("Special Characters are not Allowed");
        } else {
          setAliasError("");
        }
      }

      if (name === "project_name") {
        const selectedProject = projectData.projects.find(
          (project) => project.project_name === value
        );
        updatedState.project_id = selectedProject
          ? selectedProject.project_id
          : "";
      }

      if (name === "entry_name") {
        const selectedEntry = entriesData.entries.find(
          (entry) => entry.entry_name === value
        );
        if (selectedEntry) {
          updatedState.entry_id = selectedEntry.entry_id;
          updatedState.webURL = selectedEntry.webURL;
        } else {
          updatedState.entry_id = "";
          updatedState.webURL = "";
        }
        updatedState.schema_id = "";
        updatedState.schema_name = "";
      }
      if (name === "schema_name") {
        const selectedSchema = schemaData.schemas.find(
          (schema) => schema.schema_name === value
        );
        updatedState.schema_id = selectedSchema ? selectedSchema.schema_id : "";
      }
      return updatedState;
    });
  };
  // } else if (name === "table_name") {
  //   setFormField({
  //     ...formField,
  //     [name]: value,
  //     table_id: entryMetaData.schemas
  //       .filter((ele) => ele.schema_id === formField.schema_id)[0]
  //       .tables.filter((ele) => ele.table_name === value)[0].table_id,
  //   });
  // }
  // };

  const handleResetForm = () => {
    setFormField({
      ...INITIALSTATE,
      start_date: "",
    });
    setStartDate("");
  };

  useEffect(() => {
    if (store) {
      setTableName(
        store.map((node, i) => {
          if (node.nodeName !== "WriteToBenchling") {
            return node.formField.alias;
          }
        })
      );
    }
  }, []);

  const compareTwoArrayOfObjects = (
    first_array_of_objects,
    second_array_of_objects
  ) => {
    return (
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some(
          (element_2) =>
            element_1.header === element_2.header &&
            element_1.tableAlias === element_2.tableAlias &&
            element_1.alias === element_2.alias &&
            element_1.checked === element_2.checked
        )
      )
    );
  };

  const handleFormsubmit = async (e) => {
    e.preventDefault();

    if (
      // formField.entry_id === "" ||
      // formField.schema_id === "" ||
      // formField.table_id === ""

      formField.schema_id === "" ||
      formField.project_id === ""
    ) {
      enqueueSnackbar("Field is missing", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      return;
    }

    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    let prev_alias;
    if (store && findSrcNodeId) {
      let header = [];

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
          }
        });
      });
    }

    const getAllNodes = JSON.parse(sessionStorage.getItem("allNodes") || "[]");

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem("allNodes", JSON.stringify(newFormData));
    }

    // let y_axis = 0;
    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        // y_axis = `${parseInt(el.position.y, 10)}`;
        el.data.label = formField.alias;
      }
    });

    const newHeaderName = [];

    // headerName.forEach((item) => {
    //   newHeaderName.push({ ...item, tableAlias: formField.alias });
    // });

    fetchedHeader.forEach((item) => {
      newHeaderName.push({ ...item, tableAlias: formField.alias });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];

    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (
            count <= connectedNodes.length &&
            node.id === connectedNodes[count]
          ) {
            node.position.x += 0.1;
            count++;
          }
          return node;
        })
      );
    }

    sessionStorage.setItem("updatedNodes", JSON.stringify(connectedNodes));

    setHeaderName(newHeaderName);

    const sendFormData = {
      y_axis,
      nodeId,
      nodeName,
      formField: {
        write_benchling: {
          ...formField,
          df: prev_alias,
        },
        alias: formField.alias,
      },
      disabled: true,
      step_name: nodeName,
      headerName: newHeaderName,
      fetchedHeader,
      toggleType,
    };

    changeNodeName(nodes);

    setDisableForm(true);

    if (!errors.stream_interval) {
      setDisableForm(true);
    }
    sessionStorage.setItem("node", JSON.stringify(nodes));
    sessionStorage.setItem("edges", JSON.stringify(edges));

    const fetchNodesData = JSON.parse(
      sessionStorage.getItem("allNodes") || "[]"
    );
    fetchNodesData.push(sendFormData);

    sessionStorage.setItem("allNodes", JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(
      sessionStorage.getItem("saved_node") || "[]"
    );
    getElements.push(nodeId);
    sessionStorage.setItem("saved_node", JSON.stringify(getElements));
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);
    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });

    const getAllNodes = JSON.parse(sessionStorage.getItem("allNodes"));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el["disabled"] = false;
      }
    });

    sessionStorage.setItem("allNodes", JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem("saved_node"));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem("saved_node", JSON.stringify(newSavedElement));
  };

  const handleChecked = (event) => {
    setFormField({ ...formField, sample_view: event.target.checked });
  };

  useEffect(() => {
    fetchBenchlingProjects();
    // fetchBenchlingEntries();
    fetchSchemas();
  }, [nodeId]);

  const fetchBenchlingProjects = async () => {
    try {
      setLoading(true);
      const response = await BenchlingApi.getBenchlingProjects(axios);
      if (response.status === 200) {
        setProjectData(response.data);
        // setProjectData(PROJECT_DATA_INITIAL_STATE)
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setLoading(false);
    }
  };
  // const fetchBenchlingEntries = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await BenchlingApi.getBenchlingEntries(axios);
  //     if (response.status === 200) {
  //       setEntriesData(response.data);
  //       // setEntriesData(ENTRIES_DATA_INITIAL_STATE);
  //     }
  //   } catch (error) {
  //     if (error.response?.status === 500) {
  //       enqueueSnackbar("500 Internal Server Error!", {
  //         variant: "error",
  //         autoHideDuration: 3000,
  //         anchorOrigin: { vertical: "top", horizontal: "right" },
  //       });
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const fetchEachEntryData = async (entryId) => {
  //   try {
  //     setLoading(true);
  //     const response = await BenchlingApi.getBenchlingEntryData(axios, entryId);
  //     if (response.status === 200) {
  //       setEntryMetaData(response.data);
  //       // setEntryMetaData(entryMetaData);
  //       response.data.length === 0 &&
  //         enqueueSnackbar(`No data found for this entry`, {
  //           variant: "error",
  //           autoHideDuration: 3000,
  //           anchorOrigin: { vertical: "top", horizontal: "right" },
  //         });
  //     }
  //   } catch (error) {
  //     if (error.response?.status === 500) {
  //       enqueueSnackbar("500 Internal Server Error!", {
  //         variant: "error",
  //         autoHideDuration: 3000,
  //         anchorOrigin: { vertical: "top", horizontal: "right" },
  //       });
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   if (formField.entry_id !== "") {
  //     fetchEachEntryData(formField.entry_id);
  //   }
  // }, [formField.entry_id]);

  const fetchSchemas = async (modifiedAtParam) => {
    try {
      setLoading(true);
      const response = await BenchlingApi.getBenchlingSchemas(
        axios,
        modifiedAtParam
      );
      if (response.status === 200) {
        setSchemaData(response.data);
        if (response.data.length === 0) {
          enqueueSnackbar(`No data found for this schema`, {
            variant: "error",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        }
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (date) => {
    const formattedDate = date ? dayjs(date).format("YYYY-MM-DD") : "";
    const modifiedAtParam = formattedDate ? `> ${formattedDate}` : "";

    setStartDate(formattedDate);
    setFormField((prevFormField) => ({
      ...prevFormField,
      start_date: date,
      schema_name: "",
      schema_id: "",
    }));

    if (modifiedAtParam) {
      fetchSchemas(modifiedAtParam);
    }
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        // onClose={handleClose}
        TransitionComponent={Transition}
        style={{ width: "70%", marginLeft: "30%" }}
      >
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: "relative", backgroundColor: "#fff" }}>
            <Toolbar>
              <IconButton
                edge="start"
                onClick={handleClose}
                aria-label="close"
                sx={{ color: "#00043C" }}
              >
                <CloseIcon />
              </IconButton>
              <Typography
                sx={{ ml: 2, flex: 1, color: "#00043C" }}
                variant="h6"
                component="div"
              >
                {nodeName}
              </Typography>
              <Tooltip title="Refresh Schema" placement="left">
                <IconButton
                  disabled={disableForm}
                  edge="start"
                  onClick={refreshAllState}
                  aria-label="close"
                  sx={{ color: "#00043C" }}
                >
                  <RotateLeftIcon />
                </IconButton>
              </Tooltip>
              <ButtonGroup
                variant="contained"
                aria-label="outlined primary button group"
              >
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  className="outlined-button-color"
                  onClick={handleEdit}
                >
                  Edit
                </Button>
                <Button
                  type="submit"
                  size="small"
                  variant="contained"
                  disabled={disableForm}
                  className="button-color"
                >
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>

          <div style={{ margin: 20 }}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <InputField
                  name="alias"
                  label="Alias"
                  value={formField.alias}
                  onChange={handleInputChange}
                  size="small"
                  disabled
                  required
                  error={!!aliasError}
                  helperText={aliasError}
                  style={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={formField.sample_view}
                      onChange={handleChecked}
                      disabled={disableForm}
                    />
                  }
                  label="Sample View"
                  sx={{ pt: 1 }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: 0 }}>
              <Grid item xs={4}>
                <TextField
                  name="instrument_name"
                  label="Instrument Name"
                  value={formField.instrument_name}
                  size="small"
                  disabled
                  required
                  fullWidth
                  InputProps={{
                    style: {
                      fontFamily: "'EB Garamond', serif ",
                      fontWeight: 600,
                    },
                  }}
                  InputLabelProps={{
                    style: { fontFamily: "'EB Garamond', serif " },
                  }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: 0 }}>
              <Grid item xs={4}>
                <TextField
                  name="project_name"
                  select
                  label="Project Name"
                  value={formField.project_name}
                  onChange={handleInputChange}
                  size="small"
                  disabled={disableForm}
                  required
                  fullWidth
                  InputProps={{
                    style: {
                      fontFamily: "'EB Garamond', serif ",
                      fontWeight: 600,
                    },
                  }}
                  InputLabelProps={{
                    style: { fontFamily: "'EB Garamond', serif " },
                  }}
                >
                  {projectData.projects.map((project) => {
                    return (
                      <MenuItem
                        value={project.project_name}
                        key={project.project_id}
                      >
                        {project.project_name}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  id="outlined-basic"
                  label="Project Id"
                  variant="outlined"
                  value={formField.project_id}
                  onChange={handleInputChange}
                  name="project_id"
                  size="small"
                  fullWidth
                  disabled
                  required
                  InputProps={{
                    style: {
                      fontWeight: 600,
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: 0 }}>
              <Grid item xs={4}>
                <Autocomplete
                  options={schemaData.schemas}
                  getOptionLabel={(option) => option.schema_name}
                  value={
                    formField.schema_name
                      ? { schema_name: formField.schema_name }
                      : null
                  }
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: {
                        name: "schema_name",
                        value: newValue ? newValue.schema_name : "",
                      },
                    });
                  }}
                  inputValue={searchText}
                  onInputChange={(event, newInputValue) => {
                    setSearchText(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="schema_name"
                      label="Schema Name"
                      size="small"
                      disabled={disableForm}
                      required
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        style: {
                          fontFamily: "'EB Garamond', serif ",
                          fontWeight: 600,
                        },
                      }}
                      InputLabelProps={{
                        style: { fontFamily: "'EB Garamond', serif " },
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  id="outlined-basic"
                  label="Schema Id"
                  variant="outlined"
                  value={formField.schema_id}
                  onChange={handleInputChange}
                  name="schema_id"
                  size="small"
                  fullWidth
                  disabled
                  required
                  InputProps={{
                    style: {
                      fontWeight: 600,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  name="start_date"
                  label="Start Date"
                  value={formField.start_date}
                  onChange={(event) =>
                    handleDateChange(new Date(event.target.value))
                  }
                  size="small"
                  disabled={disableForm}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    inputComponent: ({ inputRef, ...rest }) => (
                      <DatePicker
                        {...rest}
                        ref={inputRef}
                        selected={startDate ? new Date(startDate) : null}
                        onChange={handleDateChange}
                        dateFormat="yyyy-MM-dd"
                      />
                    ),
                    style: {
                      fontFamily: "'EB Garamond', serif ",
                      fontWeight: 600,
                    },
                  }}
                  // InputLabelProps={{
                  //   style: { fontFamily: "'EB Garamond', serif " },
                  // }}
                />
              </Grid>
            </Grid>
          </div>
          {loading && <LoadingIcon />}
        </form>
      </Dialog>
      <Modal
        open={refreshModalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLoading}>
          <LoadingIcon />
        </Box>
      </Modal>
    </div>
  );
};

export default NodeModal_WriteToBenchling;
